import {
  Center,
  Flex,
} from "@chakra-ui/react";

export default function CardScope({ image, w, h }) {
  return (
    <Center>
      <Flex
        bgImage={image}
        backgroundSize={'cover'}
        backgroundPosition={'center'}
        w={w}
        h={h}
        overflow={'hidden'}
        direction={'column'}
        borderRadius={40}
      >
      </Flex>
    </Center>
  );
}
